module.exports = __webpack_public_path__ + "static/media/DonePointIcon.bb1e8713.svg";